<form [formGroup]="dateRangePickerForm" novalidate>
  <div
    fxLayout="row"
    class="date-range" 
    [ngClass]="{'margin_date_picker':sourcePage === 'filter'}">
    <div fxFlex="100" fxFlexAlign="center">
      <mat-form-field [ngClass]="{'lineheight_filter':sourcePage === 'filter'}">
        <label *ngIf="label">{{ label }}</label>
        <mat-label *ngIf="matLabel">{{ matLabel }}</mat-label>
        <mat-date-range-input [rangePicker]="picker"
          [separator]="dateRangePickerForm.value.startDate && dateRangePickerForm.value.endDate ? '-': ''">
          <input 
            matStartDate 
            formControlName="startDate"
            [disabled]="disableDatePicker" 
            (dateChange)="onSelectionChanged('start')"
            [placeholder]="sourcePage==='filter' ? 'DD/MM/YYYY' : ''">
          <input
            matEndDate
            formControlName="endDate"
            [disabled]="disableDatePicker" 
            (dateChange)="onSelectionChanged('end')"
            [placeholder]="sourcePage==='filter' ? 'DD/MM/YYYY' : ''">
        </mat-date-range-input>
        <button
          matIconSuffix
          type="button"
          mat-icon-button
          [ngClass]="{'hide-button': !displayClearButton}"
          (click)="clearDateRange()">
          <mat-icon color="primary">cancel</mat-icon>
        </button>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker [disabled]="disableToggleButton" (closed)="onDatePickerClosed()"></mat-date-range-picker>
      </mat-form-field>
    </div>
  </div>
</form>
